import { render } from "./sell-welcome.vue?vue&type=template&id=c9c9dbe8"
import script from "./sell-welcome.js?vue&type=script&lang=js"
export * from "./sell-welcome.js?vue&type=script&lang=js"

import "./sell-welcome.vue?vue&type=style&index=0&id=c9c9dbe8&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__